module.exports = __webpack_public_path__ + "img/cate2.c60743ef.png";